import { format } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { Icon } from "barte-design-system";
import { CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react";

import styles from "./calendar-header.module.css";
import type { RenderCalendarHeaderProps, RenderMonthCalendarHeaderProps } from "./calendar-header.type";

export const renderCalendarHeader = ({ date, decreaseMonth, increaseMonth }: RenderCalendarHeaderProps) => (
    <div className={styles.calendarHeader}>
        <button type="button" onClick={decreaseMonth} className={styles.calendarNavButton}>
            <Icon icon={CaretLeftIcon} />
        </button>
        <span className={styles.calendarHeaderMonth}>
            {format(date, "MMMM yyyy", { locale: ptBR })}
        </span>
        <button type="button" onClick={increaseMonth} className={styles.calendarNavButton}>
            <Icon icon={CaretRightIcon} />
        </button>
    </div>
);

export const renderMonthCalendarHeader = ({ date, decreaseYear, increaseYear }: RenderMonthCalendarHeaderProps) => (
    <div className={styles.calendarHeader}>
        <button type="button" onClick={decreaseYear} className={styles.calendarNavButton}>
            <Icon icon={CaretLeftIcon} />
        </button>
        <span className={styles.calendarHeaderMonth}>
            {format(date, "yyyy", { locale: ptBR })}
        </span>
        <button type="button" onClick={increaseYear} className={styles.calendarNavButton}>
            <Icon icon={CaretRightIcon} />
        </button>
    </div>
);
